export enum ImageResolution {
	Desktop = 'desktop',
	MOBILE = 'mobile',
	TABLE_LANDSCAPE = 'tablet-landscape',
	TABLET_PORTRAIT = 'tablet-portrait',
}
